import React, { useEffect } from 'react';
import useDishStore from '../store/dishStore';
import { Paper, Typography, Grid } from '@mui/material';
import DishCard from '../components/dishes/DishCard';
import DishEditDialog from '../components/dishes/DishEditDialog';
import AddFab from '../components/common/AddFab';
import useDishDialog from '../hooks/useDishDialog';

const DishesPage = () => {
  const { dishes, loading, error, fetchDishes } = useDishStore();

  // Use the custom dish dialog hook
  const {
    dialogOpen,
    selectedDish,
    handleDishClick,
    handleDialogClose,
    handleAddNewDish,
    handleDishSave
  } = useDishDialog();


  useEffect(() => {
    fetchDishes();
  }, []);

  if (loading) return <div>Loading dishes...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <AddFab onClick={handleAddNewDish} />
      <Grid container spacing={2} >

        {dishes.map((dish) => (
          <Grid item xs={12} sm={6} md={4} key={dish.id}>
            <DishCard
              key={dish.id}
              dish={dish}
              onDishClick={() => handleDishClick(dish)}
            />
          </Grid>

        ))}
      </Grid>

      <DishEditDialog
        open={dialogOpen}
        dish={selectedDish}
        onClose={handleDialogClose}
        onSave={handleDishSave}
      />
    </div>
  );
};

export default DishesPage;